// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1o-vP","productName":"Table_productName__3vb42"};